import * as uuid from "uuid"
import { ImageEvent } from "brandguard/brandguard.image_pb"
import { Prediction } from "brandguard/brandguard.approval_pb"

export function zero(ie: Partial<ImageEvent> = {}): ImageEvent {
	return {
		id: uuid.NIL,
		account_id: uuid.NIL,
		brand_id: uuid.NIL,
		approved: Prediction.NONE,
		observation: Prediction.NONE,
		queue: "",
		confidence: 0.0,
		brand_uniqueness: 0.0,
		brand_voice: 0.0,
		sexually_explicit: 0.0,
		image_quality_general: 0.0,
		image_violence: 0.0,
		image_logo_detection: 0.0,
		image_logo_colors: 0.0,
		image_logo_distortion: 0.0,
		image_lookandfeel_checks: 0n,
		image_lookandfeel_violations: 0n,
		image_lookandfeel_conformance: 0.0,
		image_font_detection: 0.0,
		image_logo_clearspace: 0.0,
		image_background_colors: 0.0,
		updated_at: "",
		artifact_score: 0.0,
		artifact_match_description: "",
		artifact_match_training_id: "",
		onbrand_score: 0.0,
		ai_generated: false,
		...ie,
	}
}
